module.exports = __webpack_public_path__ + "img/visa-card.bee8bb6c.svg";